// extracted by mini-css-extract-plugin
export default {"sub-title":"M0Y2Bv","subTitle":"M0Y2Bv","spacer-20":"Cnrs4g","spacer20":"Cnrs4g","quantity":"rJKWWn"};